import React from "react";

import { Row, Col, Card, CardImg, Table, Button } from "react-bootstrap";
import { InfoSquare, Download } from "react-bootstrap-icons";


const moneyFormater = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "PGK"
});

export const ReceiptRetrieved = ({ item, reportStr }) => {

    const downloadRcpt = () => {
        if(!reportStr){
            return
        }
        const filename = `e-Receipt.pdf`;
        const link = document.createElement("a");
        let data = 'data:application/pdf;base64,' + reportStr;
        link.setAttribute("href", data);
        link.setAttribute("download", filename);
        link.click();
    };

    return (
        <Card className="mt-5">
            {/* <img
                style={{zIndex: 1, width: "100%", height:"100%", position: "absolute", borderRadius: 5, opacity: 0.4}}
                className="img-responsive"
                src={'./media/svg/patterns/taieri.svg'}
                alt="Visit your service provider"
            /> */}
            <Card.Header>
                <h4> 
                    <InfoSquare size={26} /> Receipt Details - <b> {item.rcpt_number} </b> 
                </h4>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col className="m-3">
                        <p className="text-muted"> Present your receipt at the respective agency to receive your service. </p>
                        <Table className="bg-white">
                            <tbody>
                                <tr>
                                    <td> <b> Receipt Issued on: </b> </td>
                                    <td> { item.rcpt_issued_date } </td>
                                </tr>
                                <tr>
                                    <td> <b> Receipt Number: </b> </td>
                                    <td> {item.rcpt_number} </td>
                                </tr>
                                <tr>
                                    <td> <b> Receipt Status: </b> </td>
                                    <td> {item.rcpt_status_desc} </td>
                                </tr>
                                <tr>
                                    <td> <b> Customer: </b> </td>
                                    <td> {item.cust_first_name} {item.cust_last_name}  </td>
                                </tr>
                                <tr>
                                    <td> <b> Mobile Number: </b> </td>
                                    <td> {item.cust_msisdn} </td>
                                </tr>
                                <tr>
                                    <td> <b> Province: </b> </td>
                                    <td> {item.province_name} </td>
                                </tr>
                                <tr>
                                    <td> <b> Department: </b> </td>
                                    <td> {item.dept_name} </td>
                                </tr>
                                <tr>
                                    <td> <b> Revenue Code: </b> </td>
                                    <td> {item.service_item_number} </td>
                                </tr>
                                <tr>
                                    <td> <b> Service Item Description: </b> </td>
                                    <td> {item.service_item_desc} </td>
                                </tr>
                                <tr>
                                    <td> <b> Amount Paid for Service: </b> </td>
                                    <td> <b> { moneyFormater.format(item.total_amnt) } </b> </td>
                                </tr>
                            </tbody>
                        </Table>
                        <hr/>
                        <Button variant="info" onClick={downloadRcpt}>
                            <Download size={15} /> {" "} Download Receipt
                        </Button>
                    </Col>
                    <Col className="m-3">
                        <Card  >
                            <CardImg
                                variant="top"
                                src="../media/products/rpngc_card_bg.png"
                            />
                            <Card.Body>
                                <Col lg={12} md={12} sm={12}>
                                    <Row>
                                        <Col> <b> Receipt Number: </b> </Col>
                                        <Col> { item.rcpt_number } </Col> 
                                    </Row>
                                    <Row> 
                                        <Col> <b> Department: </b> </Col>
                                        <Col> { item.dept_name } </Col> 
                                    </Row>
                                    <Row>
                                        <Col> <b> Province: </b> </Col>
                                        <Col> { item.province_name } </Col> 
                                    </Row>
                                    <Row> 
                                        <Col> <b> Service: </b> </Col>
                                        <Col> { item.service_name } </Col>  
                                    </Row>
                                    <Row>
                                        <Col> <b> Service Description: </b> </Col>
                                        <Col> { item.service_desc } </Col> 
                                    </Row>
                                    <Row>
                                        <Col> <b> Total Amount: </b> </Col>
                                        <Col> { moneyFormater.format(item.total_amnt) } </Col> 
                                    </Row>
                                </Col>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
            </Card.Body>
            
        </Card>
    );
};